import React from "react";
import TrakingOrder from "../../components/TrakingOrder";

const OrderTrackingPage = () => {
  return (
      <TrakingOrder />
  );
};

export default OrderTrackingPage;